/**
 * Main application entry point.
 */

'use strict';

var keys = require('stb-keys'),
    app = require('mag-app');

if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    window.removeEventListener('keydown', require('spa-app/lib/events').keydown);
    require('../../../helpers/longpress.js')(app, {code: keys.ok, emitCode: keys.menu});
}

app.once('load', function () {
    app.api = core.plugins.videoBackend;

    app.api.config = {
        sort: '',
        genreId: '',
        categoryId: '',
        favorite: false,
        search: '',
        limit: 0
    };

    require('spa-gettext').load({name: core.environment.language}, function ( error ) {
        if ( error ) {
            debug.inspect(error);
        }

        // load pages
        app.pages = {
            main: require('./pages/main'),
            info: require('./pages/info')
        };

        // show main page
        app.route(app.pages.main);
    });
});
